import _defineProperty from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useRef, useEffect, useCallback } from "react";
import style from "./Dropdown.module.css";
import classes from "react-style-classes";
import Item from "./Item";
import Submenu from "./Submenu";

var Dropdown = function Dropdown(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var dropdownRef = useRef();
  return /*#__PURE__*/React.createElement("div", {
    className: classes(style.dropdown, props.wrapperClassName),
    ref: dropdownRef,
    onMouseEnter: function onMouseEnter() {
      return setOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("button", _defineProperty({
    type: "button",
    className: classes(style.button, isOpen && style.active, props.isDisabled && style.disabled, props.buttonClassName),
    disabled: props.isDisabled,
    tabIndex: 0,
    onClick: props.onClick
  }, "onClick", props.onClick), props.title), isOpen && /*#__PURE__*/React.createElement("div", {
    className: classes(style.menu, props.position === "right" && style.menuRight, props.menuClassName)
  }, /*#__PURE__*/React.createElement("ul", null, props.children)));
};

Dropdown.defaultProps = {
  children: null,
  onClick: function onClick() {
    return null;
  },
  isDisabled: false,
  title: null,
  position: "left",
  wrapperClassName: null,
  buttonClassName: null,
  menuClassName: null
};
Dropdown.Item = Item;
Dropdown.Submenu = Submenu;
export default Dropdown;